

export const frontMatter = {
	title: 'Dnd',
	sidebar_position: 1
};
export const contentTitle = 'Drag And Drop';
export const metadata = {
  "id": "core/dnd/dragAndDrop",
  "title": "Dnd",
  "description": "The dock makes heavy use of drag and drop functionalities.",
  "source": "@site/docs/core/dnd/dragAndDrop.mdx",
  "sourceDirName": "core/dnd",
  "slug": "/core/dnd/dragAndDrop",
  "permalink": "/docs/core/dnd/dragAndDrop",
  "draft": false,
  "unlisted": false,
  "tags": [],
  "version": "current",
  "sidebarPosition": 1,
  "frontMatter": {
    "title": "Dnd",
    "sidebar_position": 1
  },
  "sidebar": "tutorialSidebar",
  "previous": {
    "title": "Overview",
    "permalink": "/docs/core/dnd/overview"
  },
  "next": {
    "title": "Third Party Libraries",
    "permalink": "/docs/core/dnd/thirdParty"
  }
};
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import useBaseUrl from '@docusaurus/useBaseUrl';
import {MultiFrameworkContainer} from '@site/src/components/ui/container';
import DockviewExternalDnd from '@site/sandboxes/externaldnd-dockview/src/app';
import LiveExample from '@site/src/components/ui/exampleFrame';
import {DocRef} from '@site/src/components/ui/reference/docRef';
export const toc = [{
  "value": "Extended behaviours",
  "id": "extended-behaviours",
  "level": 2
}, {
  "value": "Third Party Dnd Libraries",
  "id": "third-party-dnd-libraries",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    h2: "h2",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "The dock makes heavy use of drag and drop functionalities."
    }), "\n", _jsx(DocRef, {
      declaration: "DockviewApi",
      methods: ['onWillDragPanel', 'onWillDragGroup', 'onWillDrop', 'onWillShowOverlay']
    }), "\n", _jsx(LiveExample, {
      framework: "react",
      id: "dockview/dnd-events"
    }), "\n", _jsx(_components.h1, {
      id: "drag-and-drop",
      children: "Drag And Drop"
    }), "\n", _jsxs(_components.p, {
      children: ["You can override the conditions of the far edge overlays through the ", _jsx(_components.code, {
        children: "dndEdges"
      }), " prop."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "<DockviewReact\n  {...props}\n   dndEdges={{\n    size: { value: 100, type: 'pixels' },\n    activationSize: { value: 5, type: 'percentage' },\n  }}\n  />\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "extended-behaviours",
      children: "Extended behaviours"
    }), "\n", _jsx(_components.p, {
      children: "For interaction with the Drag events directly the component exposes some method to help determine whether external drag events should be interacted with or not."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "/**\n * called when an ondrop event which does not originate from the dockview libray and\n * passes the onUnhandledDragOverEvent condition\n **/\nconst onDidDrop = (event: DockviewDropEvent) => {\n    const { group } = event;\n\n    event.api.addPanel({\n        id: 'test',\n        component: 'default',\n        position: {\n            referencePanel: group.activePanel.id,\n            direction: 'within',\n        },\n    });\n};\n\nconst onReady = (event: DockviewReadyEvent) => {\n\n  /**\n   * called for drag over events which do not originate from the dockview library\n   * allowing the developer to decide where the overlay should be shown for a\n   * particular drag event\n   **/\n  api.onUnhandledDragOverEvent(event => {\n    event.accept();\n  });\n}\n\nreturn (\n    <DockviewReact\n        components={components}\n        onReady={onReady}\n        className=\"dockview-theme-abyss\"\n        onDidDrop={onDidDrop}\n    />\n);\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "third-party-dnd-libraries",
      children: "Third Party Dnd Libraries"
    }), "\n", _jsxs(_components.p, {
      children: ["This shows a simple example of a third-party library used inside a panel that relies on drag\nand drop functionalities. This examples serves to show that ", _jsx(_components.code, {
        children: "dockview"
      }), " doesn't interfer with\nany drag and drop logic for other controls."]
    }), "\n", _jsx(MultiFrameworkContainer, {
      sandboxId: "externaldnd-dockview",
      react: DockviewExternalDnd
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

